import React, { useState, useEffect, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DivLayout from "components/sales/divLayout/divLayout";
import ListFilters from "components/sales/ListFilters/ListFilters";

const ScoreByHod = ({
  match,
  fetchSelfScorecardByHod,
  getUserScoreByHod = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await fetchSelfScorecardByHod(null);
      setIsLoading(false);
    })();
  }, []);

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await fetchSelfScorecardByHod(filterData);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout title={"HOD Scorecard"} isLoading={isLoading} Buttons={headerBtns} linkFlag>
    {getUserScoreByHod && getUserScoreByHod[0] ? (
        <>
          <div className="panel-card">
            <div className="panel-heading">{`HOD Scorecard`}</div>
            <div className="panel-body">
              <div className="details-listing">
                <DivLayout
                  heading={"Score By HOD"}
                  data={
                    getUserScoreByHod[0]?.scoreByHod
                      ? `${getUserScoreByHod[0]?.scoreByHod}`
                      : "N/A"
                  }
                />
                <DivLayout
                  heading={"Last Month Score"}
                  data={
                    getUserScoreByHod[0]?.lastMonthScore
                      ? `${getUserScoreByHod[0]?.lastMonthScore}`
                      : "N/A"
                  }
                />
                <DivLayout
                  heading={"HOD Feedback"}
                  data={
                    getUserScoreByHod[0]?.hodFeedback
                      ? `${getUserScoreByHod[0]?.hodFeedback}`
                      : "N/A"
                  }
                />
                <DivLayout
                  heading={"Highest Performer"}
                  data={
                    getUserScoreByHod[0]?.highestPerformer
                      ? `${getUserScoreByHod[0]?.highestPerformer}`
                      : "N/A"
                  }
                />
                <DivLayout
                  heading={"Highest Score"}
                  data={
                    getUserScoreByHod[0]?.highestScore
                      ? `${getUserScoreByHod[0]?.highestScore}`
                      : "N/A"
                  }
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>
          <img src={Images?.NoData} alt="No Data Found" width="100%" />
        </div>
      )}
    <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        meetingRatingsFilter
        type={"HOD"}
        userFilter={false}
    />
    </Layout>
  );
};

export default ScoreByHod;
